var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.84C16.24 17.368 19.36 13.432 19.36 8.12803V3.08803C16.696 1.16803 13.456 0.160034 10 0.160034C6.54401 0.160034 3.30401 1.16803 0.640015 3.08803V8.12803C0.640015 13.432 3.76002 17.368 10 19.84ZM2.56001 8.12803V4.00003C4.79202 2.60803 7.19202 1.96003 10 1.96003C12.808 1.96003 15.208 2.60803 17.44 4.00003V8.12803C17.44 12.64 15.208 15.64 10 17.872C4.79202 15.64 2.56001 12.64 2.56001 8.12803ZM5.32001 9.06403C5.32001 9.18403 5.34402 9.28003 5.41602 9.37603L7.52802 12.808C8.05602 13.72 9.01602 14.296 10.12 14.296C11.752 14.296 13.048 13.048 13.144 11.416L13.264 5.82403C13.264 5.53603 13.048 5.29603 12.76 5.29603C12.472 5.29603 12.256 5.53603 12.256 5.80003L12.184 8.80003H11.656L11.68 4.79203C11.68 4.50403 11.488 4.26403 11.176 4.26403C10.888 4.26403 10.672 4.50403 10.672 4.76803L10.648 8.56003H10.12L10.096 4.26403C10.096 4.00003 9.90402 3.76003 9.59202 3.76003C9.30402 3.76003 9.08802 4.00003 9.08802 4.28803L9.11202 8.80003H8.56002L8.51202 5.29603C8.51202 5.03203 8.32002 4.76803 8.00802 4.76803C7.69602 4.76803 7.50402 5.03203 7.50402 5.32003L7.57602 10.528L6.47202 8.72803C6.37602 8.53603 6.16002 8.41603 5.94402 8.41603C5.58401 8.41603 5.32001 8.68003 5.32001 9.06403Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.18c22c4296a7de8e28c62e4a0ed4de9c.svg";
export { ForwardRef as ReactComponent };